import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-loading';
import { Form } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useMutation } from '@apollo/react-hooks';
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';

import { Main, Button, Send } from './styles';

import { ADD_MALL, UPDATE_MALL } from '../../../services/graphql/mutations';

import { schema, formInitialState, formErrorInitialState } from './constants';

export default function Modal({
  edit,
  onClose,
  selectedValue,
  open,
  countries,
  selected = {}
}) {
  const [
    { code, name, lat, lon, address, active, country_id },
    setFormState
  ] = React.useState(formInitialState);
  const [
    {
      codeError,
      nameError,
      latError,
      lonError,
      addressError,
      activeError,
      country_idError
    },
    setFormErrorState
  ] = React.useState(formErrorInitialState);

  const [addMall, { loading: addLoading }] = useMutation(ADD_MALL);
  const [updateMall, { loading: updateLoading }] = useMutation(UPDATE_MALL);

  useEffect(() => {
    if (open) {
      setFormState(formInitialState);
      setFormErrorState(formErrorInitialState);
    }

    if (edit && open) {
      const { code, name, lat, lon, address, active, country_id } = selected;

      setFormState({
        code,
        name,
        lat,
        lon,
        address,
        active,
        country_id
      });
    }
  }, [open, edit, selected]);

  function handleOnChange(name, value) {
    setFormState(prevState => ({ ...prevState, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setFormErrorState(formErrorInitialState);

      await schema.validate(
        { code, name, lat, lon, address, active, country_id },
        { abortEarly: false }
      );

      if (edit) {
        const editMallInput = {
          id: selected.id,
          code,
          name,
          lat: Number(lat),
          lon: Number(lon),
          address,
          active,
          country_id
        };

        await updateMall({
          variables: {
            editMallInput
          }
        });
      } else {
        const mallInput = {
          code,
          name,
          lat: Number(lat),
          lon: Number(lon),
          country_id,
          address,
          active
        };

        await addMall({
          variables: {
            mallInput
          }
        });
      }

      setFormState(formInitialState);

      let successMessage;

      if (edit) successMessage = 'El registro fue editado exitosamente';
      else successMessage = 'El registro fue creado exitosamente';

      toast.success(successMessage);

      handleClose();
    } catch (err) {
      if (err.inner) {
        err.inner.map(error =>
          setFormErrorState(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
      } else {
        let errorMessage;

        if (edit) errorMessage = 'Error al intentar actualizar el registro';
        else errorMessage = 'Error al intentar crear el registro';

        toast.error(errorMessage);
      }
    }
  }

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {edit ? 'Editar' : 'Ingresar'} Centro Comercial
      </DialogTitle>
      <Main data-testid="modal-component">
        <Form>
          <Form.Group>
            <Form.Input
              error={nameError}
              label="Nombre *"
              placeholder="Nombre"
              width={4}
              value={name}
              onChange={(e, { value }) => handleOnChange('name', value)}
              className="plateInput"
            />
            <Form.Input
              error={codeError}
              label="Codigo *"
              placeholder="Codigo"
              width={4}
              value={code}
              onChange={(e, { value }) => handleOnChange('code', value)}
              className="plateInput"
            />
            <Form.Select
              error={country_idError}
              label="País *"
              placeholder="Seleccione País"
              options={countries}
              width={4}
              value={country_id}
              onChange={(e, { value }) => handleOnChange('country_id', value)}
            />
            <Form.Input
              error={addressError}
              label="Dirección *"
              placeholder="Dirección"
              width={8}
              value={address}
              onChange={(e, { value }) => handleOnChange('address', value)}
              className="plateInput"
            />
          </Form.Group>

          <Form.Group>
            <Form.Input
              error={latError}
              label="Latitude *"
              placeholder="Latitude"
              width={4}
              value={lat}
              onChange={(e, { value }) => handleOnChange('lat', value)}
              className="plateInput"
            />
            <Form.Input
              error={lonError}
              label="Longitud *"
              placeholder="Longitud"
              width={4}
              value={lon}
              onChange={(e, { value }) => handleOnChange('lon', value)}
              className="plateInput"
            />
          </Form.Group>

          <Form.Group>
            <Form.Checkbox
              error={activeError}
              label="Activo"
              placeholder="Activo"
              width={2}
              onClick={() => handleOnChange('active', !active)}
              checked={active}
            />
          </Form.Group>
        </Form>
        <Button onClick={handleSubmit} data-testid="send-button">
          {addLoading || updateLoading ? (
            <Loading height={15} width={15} type="spin" />
          ) : (
            <Send>
              <MdSend />
              Enviar
            </Send>
          )}
        </Button>
      </Main>
    </Dialog>
  );
}

Modal.propTypes = {
  edit: PropTypes.bool,
  onClose: PropTypes.func,
  selectedValue: PropTypes.any,
  open: PropTypes.bool,
  selected: PropTypes.object,
  countries: PropTypes.array
};
